export default __webpack_public_path__ + "static/media/icon-error.3bf08602.svg";